import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ============================================================================
// Types
// ============================================================================

export interface DefectTrackerFilters {
    searchInput: string;
    startDate: string;
    endDate: string;
    defectIdFilter: string;
    projectFilter: string[];
    moduleFilter: string;
    assignedToFilter: string[];
    priorityFilter: string[];
    statusChecked: boolean[];
    currentPage: number;
    pageSize: number;
}

export interface DefectTrackerFiltersState {
    filters: DefectTrackerFilters;
}

// ============================================================================
// Initial State
// ============================================================================

const initialState: DefectTrackerFiltersState = {
    filters: {
        searchInput: '',
        startDate: '',
        endDate: '',
        defectIdFilter: '',
        projectFilter: [],
        moduleFilter: '',
        assignedToFilter: [],
        priorityFilter: [],
        statusChecked: [false, false, false, false, false, false, false],
        currentPage: 1,
        pageSize: 10
    }
};

// ============================================================================
// Slice
// ============================================================================

const defectTrackerFiltersSlice = createSlice({
    name: 'defectTrackerFilters',
    initialState,
    reducers: {
        setDefectTrackerFilters: (state, action: PayloadAction<Partial<DefectTrackerFilters>>) => {
            state.filters = { ...state.filters, ...action.payload };
        },
        resetDefectTrackerFilters: (state) => {
            state.filters = initialState.filters;
        }
    }
});

// ============================================================================
// Exports
// ============================================================================

export const {
    setDefectTrackerFilters,
    resetDefectTrackerFilters
} = defectTrackerFiltersSlice.actions;

export default defectTrackerFiltersSlice.reducer;

// ============================================================================
// Selectors
// ============================================================================

export const selectDefectTrackerFilters = (state: { defectTrackerFilters: DefectTrackerFiltersState }) =>
    state.defectTrackerFilters.filters;
